import { Button } from "@mui/material";
import ServiceItem from "components/Layout/ServiceItem/ServiceItem";
import { toast } from "react-toastify";
import ClienteService from "services/cliente";

export function ConfirmationServiceItem({ service, occurrence }) {
  return (
    <ServiceItem key={`service-${occurrence.id}`} title={service.descricao}>
      <>
        {occurrence.linkPagtoMP ? (
          <>
            O serviço solicitado será efetuado até 3 dias úteis após a
            confirmação do pagamento, e o prazo de atendimento começará ser
            contado a partir da data do pagamento.
            <br />
            <div
              style={{
                marginTop: "16px",
              }}
            />
            Protocolo:
            <span
              style={{
                float: "right",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              {occurrence["v-nr-ocorrencia"] || "Não encontrado"}
            </span>
            <div
              style={{
                marginTop: "16px",
              }}
            />
            <p>
              O Link de Pagamento foi enviado para o e-mail cadastrado:{" "}
              {ClienteService.localEntrega.email}
            </p>
            <>
              <style>
                {`
                      .scroll-x-hidden {
                        overflow-x: auto;          /* mantém scroll horizontal */
                        -ms-overflow-style: none;  /* IE/Edge antigo */
                        scrollbar-width: none;     /* Firefox */
                      }
            
                      .scroll-x-hidden::-webkit-scrollbar {
                        display: none;             /* Chrome / Safari / Edge */
                      }
                    `}
              </style>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <div
                  className="scroll-x-hidden"
                  style={{
                    border: "solid 1px #c2c2c2",
                    backgroundColor: "#e9e9e9",
                    borderRadius: "80px",
                    height: "50px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    position: "relative",
                    paddingInline: "12px",
                  }}
                >
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: "500",
                      fontSize: "14px",
                      position: "relative",
                      paddingLeft: "12px",
                      color: "#000",
                    }}
                  >
                    {occurrence.linkPagtoMP}
                  </span>
                </div>
                <Button
                  variant="contained"
                  sx={{
                    height: "40px",
                    borderRadius: "100px",
                  }}
                  onClick={() => {
                    navigator.clipboard
                      .writeText(occurrence.linkPagtoMP)
                      .then(() => {
                        toast.success("Link copiado!");
                      })
                      .catch((err) => {
                        console.error("Erro ao copiar:", err);
                      });
                  }}
                >
                  Copiar
                </Button>
              </div>
            </>
          </>
        ) : (
          <>
            {occurrence.deadline &&
              `Serviço previsto para até o dia ${occurrence.deadline}`}
            <br />
            Protocolo:
            <span
              style={{
                float: "right",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              {occurrence.protocol || "Não encontrado"}
            </span>
            {((occurrence.price ||
              (occurrence.complementaryData &&
                !occurrence.complementaryData.length &&
                occurrence.complementaryData.value)) && (
              <p style={{ margin: 0 }}>
                O boleto será enviado para o email cadastrado após a execução do
                serviço.
              </p>
            )) ||
              ""}
          </>
        )}
      </>
    </ServiceItem>
  );
}
